import { Box, TextField, Typography, Paper } from "@mui/material";
import React, { useState, useEffect, useRef, useCallback } from "react";
import FloatingSearchBar from "../../../components/FloatingSearchBar/FloatingSearchBar";
import ConfigurableTabs from "../../../components/Tabs/Tabs";
import useSave from "../../../Hooks/useSave";
import { useNavigate, useParams } from "react-router-dom";
import { Button, IconButton, Input, Tooltip, Dialog } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { SafetyCheck } from "@mui/icons-material";
import useAlert from "../../../Hooks/useAlerts";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Fab from "@mui/material/Fab";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { usePrompt } from "../../../Hooks/useBlocker";
import useProtectView from "../../../Hooks/useProtectView";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

//create date
const today = new Date();
const tomorow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export default function NewOrderCustomer() {
  const { fetchGraphql, DialogSave } = useSave();
  const { id } = useParams();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isBig = useMediaQuery(theme.breakpoints.up("sm"));
  const ref = useRef();
  const biRef = {};
  const canView = useProtectView();
  const onRefChange = useCallback((node) => {
    // console.log(node);
    if (node === null) {
      // DOM node referenced by ref has been unmounted
      setLoadingComponent(false);
    } else {
      // DOM node referenced by ref has changed and exists
      // console.log("here");
    }
  }, []); // adjust deps

  const [searchField, setSearchField] = useState("");
  const [selected, setSelected] = useState(false);
  const [stillTypeing, setStillTypeing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [addAlert, Feedback] = useAlert();
  const [customersOptions, setCustomersOptions] = useState([]);
  const [order, setOrder] = useState({
    deliveryDate: tomorow,
  });
  const [products, setProducts] = useState([]);
  const [orderedProducts, setOrderedProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [page, setPage] = useState("order");
  const [shift, setShift] = useState(false);
  const [loadingComponent, setLoadingComponent] = useState(false);

  // const [saved, setSaved] = useState(true);

  // const isFirstRender = useRef(1);

  // console.log(!saved);

  // usePrompt("If you leave without saving you will loss your data?", !saved);

  // useEffect(() => {
  //   if (isFirstRender.current === 1 || isFirstRender.current === 2) {
  //     isFirstRender.current = isFirstRender.current + 1;
  //     return;
  //   }

  //   setSaved(false);

  //   // console.log(products);
  // }, [products]);

  useEffect(() => {
    const filteredProducts = selected
      ? products
          ?.filter((item) => item.quantity > 0)
          .filter(
            (item) =>
              item?.productName
                ?.toLowerCase()
                .includes(searchField?.toLowerCase()) ||
              item?.productCode
                ?.toLowerCase()
                .includes(searchField?.toLowerCase()),
          )
      : products?.filter(
          (item) =>
            item?.productName
              ?.toLowerCase()
              .includes(searchField?.toLowerCase()) ||
            item?.productCode
              ?.toLowerCase()
              .includes(searchField?.toLowerCase()),
        );

    setFilteredProducts(filteredProducts);
  }, [selected, searchField]);

  useEffect(() => {
    fetchGraphql({
      query: `query Products ($orderId: ID!) {
        products {
          productId
          productCode
          productName
          productDescription
          productCategory
          priceByPound
          sortOrder
        } 
        customers {
          customerName
          customerId
        }
        order (orderId: $orderId) {
          customerId
          customerName
          deliveryDate
          orderNote
        }
        orderProducts (orderId: $orderId) {
          productId
          orderProductId
          quantity
        }
      }`,
      variables: { orderId: id },
    }).then((result) => {
      const map = new Map();
      console.log("from 155 of new order", result);
      result.data.products.forEach((item) => map.set(item.productId, item));

      result.data.orderProducts.forEach((item) =>
        map.set(item.productId, { ...map.get(item.productId), ...item }),
      );

      const mergedArr = Array.from(map.values());
      // console.log(mergedArr);

      setProducts(mergedArr);
      setFilteredProducts(mergedArr);
      setCustomersOptions(
        result.data.customers.map((item) => ({
          ...item,
          label: item.customerName,
        })),
      );
      setLoading(false);
      setOrder(result.data.order);

      if (result.data.customers.length <= 1) {
        setOrder({
          ...result.data.order,
          customerId: result.data.customers[0].customerId,
          customerName: result.data.customers[0].customerName,
        });

        updateOrder({
          ...result.data.order,
          customerId: result.data.customers[0].customerId,
        });
      }
    });

    return () => {};
  }, []);

  useEffect(() => {
    if (page === "order" && loadingComponent) {
      setPage("products");
    }

    // console.log("loading", loadingComponent, onRefChange, page);
  }, [loadingComponent]);

  const handleOnChange = (e) => {
    setSearchField(e.target.value);
  };

  const typeing = (save) => {
    clearTimeout(stillTypeing);

    // console.log(save);

    setStillTypeing(setTimeout(() => save(), 3000));
  };

  const save = (e, item) => {
    const copyState = [...products];
    const row = copyState.find((row) => row.productId === item.productId);

    if (e.target.value === ".") {
      if (row.productCategory === "Cake by Sheet") {
        row.quantity = e.target.value;

        setProducts(copyState);

        return;
      }
    }

    async function deleteOrderProduct() {
      return fetchGraphql({
        query: `mutation DeleteOrderProduct($orderProductId: ID!, $orderId: ID) {
            deleteOrderProduct(orderProductId: $orderProductId, orderId: $orderId)
          }`,
        variables: { orderId: id, orderProductId: item.orderProductId },
      }).then((result) => {
        if (!result.errors) {
          addAlert({ severity: "success", message: "Saved Succesfuly" });
        } else {
          addAlert({ severity: "error", message: "Error updateing order" });
        }

        return Promise.resolve(result);
      });
    }

    async function createOrderProduct() {
      return fetchGraphql({
        query: `mutation CreateOrderProduct($orderId: ID, $product: orderProductInput) {
            createOrderProduct(orderId: $orderId, product: $product)
          }`,
        variables: {
          orderId: id,
          product: {
            quantity:
              row.productCategory === "Cake by Sheet"
                ? parseFloat(e.target.value)
                : parseInt(e.target.value) || null,
            productId: row.productId,
          },
        },
      }).then((result) => {
        console.log(result);
        if (!result.errors) {
          addAlert({ severity: "success", message: "Saved Succesfuly" });
        } else {
          addAlert({ severity: "error", message: "Error updateing order" });
        }

        return Promise.resolve(result);
      });
    }

    async function updateOrderProduct() {
      return fetchGraphql({
        query: `mutation UpdateOrderProduct($orderProductId: ID, $orderId: ID!,  $product: orderProductInput) {
          updateOrderProduct(orderProductId: $orderProductId, product: $product, orderId: $orderId) {
            orderProductId
            orderId
            productId
            productCode
            productName
            productPrice
            quantity
            priceByPound
          }
        }`,
        variables: {
          orderId: id,
          orderProductId: item.orderProductId,
          product: {
            quantity:
              row.productCategory === "Cake by Sheet"
                ? parseFloat(e.target.value)
                : parseInt(e.target.value) || null,
            productId: row.productId,
          },
        },
      }).then((result) => {
        console.log(result);
        if (!result.errors) {
          addAlert({ severity: "success", message: "Saved Succesfuly" });
        } else {
          addAlert({ severity: "error", message: "Error updateing order" });
        }

        return Promise.resolve(result);
      });
    }

    if (!e.target.value && item.orderProductId) {
      // console.log("save 5", " in database and was now deleted");
      // in database and was now deleted
      if (e._reactName === "onBlur") {
        clearTimeout(stillTypeing);

        deleteOrderProduct().then((result) => {
          if (result.data.deleteOrderProduct) delete row.orderProductId;

          setProducts(copyState);
        });
      } else {
        typeing(() => {
          deleteOrderProduct().then((result) => {
            if (result.data.deleteOrderProduct) delete row.orderProductId;

            setProducts(copyState);
          });
        });
      }
    } else if (!e.target.value && !item.orderProductId) {
      // console.log("save", "tab");

      clearTimeout(stillTypeing);
    } else if (e.target.value && !item.orderProductId) {
      //new item that was never saved
      if (e._reactName === "onBlur") {
        // console.log("save", " new item that was never saved", e, item);
        clearTimeout(stillTypeing);

        createOrderProduct().then((result) => {
          // console.log("here");
          row.orderProductId = result.data.createOrderProduct;

          setProducts(copyState);
        });
      } else {
        typeing(() => {
          // console.log("save 2", " new item that was never saved", e, item);

          createOrderProduct().then((result) => {
            // console.log("here 2", result);
            row.orderProductId = result?.data?.createOrderProduct;

            setProducts(copyState);
          });
        });
      }
    } else if (e.target.value && item.orderProductId) {
      //was saved and now its being updated
      if (e._reactName === "onBlur") {
        // console.log("save 3", "/was saved and now its being updated");
        clearTimeout(stillTypeing);

        updateOrderProduct();
      } else {
        typeing(() => updateOrderProduct());
      }
    }

    row.quantity =
      row.productCategory === "Cake by Sheet"
        ? parseFloat(e.target.value)
        : parseInt(e.target.value) || null;

    setProducts(copyState);
  };

  function saveOrder(order) {
    const graphqlOrder = { ...order };

    delete graphqlOrder.customerName;

    graphqlOrder.deliveryDate = new Date(graphqlOrder.deliveryDate);

    fetchGraphql({
      query: `mutation UpdateOrder($orderId: ID!, $order: orderInput) {
        updateOrder(orderId: $orderId, order: $order) {
          customerId
          customerName
          deliveryDate
          orderNote
        }
      }`,
      variables: { orderId: id, order: graphqlOrder },
    }).then((result) => {
      if (!result.errors) {
        addAlert({ severity: "success", message: "Saved Succesfuly" });
      } else {
        addAlert({ severity: "error", message: "Error updateing order" });
      }

      setOrder(result.data.updateOrder);
    });
  }

  function updateOrder(order) {
    typeing(() => saveOrder(order));
  }

  function handleBlur(e, item) {
    if (e.target.value < 0) return;
    clearTimeout(stillTypeing);

    save(e, item);
  }

  function handleChange(e, item) {
    if (e.target.value < 0) return;

    save(e, item);
  }

  const handleKeyUp = (event) => {
    if (event.key === "Shift") {
      setShift(false);
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.repeat) {
      return;
    } else if (event.key === "Tab") {
      if (shift && index === 0) {
        event.preventDefault();
        biRef.focus();
      }
    } else if (event.key === "Shift") {
      setShift(true);
    }
  };

  const handleSearchKeyDown = (event) => {
    if (event.repeat) {
      return;
    } else if (event.key === "Tab") {
      event.preventDefault();
      ref.current.focus();
    }
  };

  const sortBy = (a, b) => {
    if (!a) return -1;
    if (!b) return +1;

    // console.log(a, b);
    return a - b;
  };

  const groupBy = (items, key) => {
    return items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {},
    );
  };

  const groupedByCategory = groupBy(filteredProducts, "productCategory");

  const tabs = Object.keys(groupedByCategory)
    .sort((a, b) => a.localeCompare(b))
    .map((item1, i) => ({
      label: item1 === "" ? "Uncategorized" : item1,
      content: (
        <Paper
          sx={{ margin: "10px auto", maxWidth: "800px" }}
          elevation="6"
          key={`${i}`}
        >
          <Typography
            sx={{
              // borderBottom: "solid 2px rgb(0,0,0,.4)",
              textAlign: "center",
              fontStyle: "italic",
              padding: "20px",
            }}
            fontSize={30}
          >
            {item1 === "" ? "Uncategorized" : item1}
          </Typography>

          {groupedByCategory[item1]
            .sort((a, b) => sortBy(a.sortOrder, b.sortOrder))
            .map((item, index) => {
              return (
                <Box
                  sx={{
                    backgroundColor: `${
                      Number.isInteger(index / 2) ? "#f2f2f2" : ""
                    }`,
                    padding: "5px",
                    // display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr",
                  }}
                  key={`${i}${index}`}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ marginLeft: "10px" }} fontSize={16}>
                      {item.productCode +
                        " - " +
                        item.productName +
                        (item.priceByPound ? " - P/LB" : "") +
                        (item.minQuantity ? ` - M.Q./${item.minQuantity}` : "")}
                    </Typography>

                    <Typography sx={{ marginLeft: "10px" }} fontSize={10}>
                      {item.productDescription}
                    </Typography>
                  </Box>

                  <TextField
                    type="tel"
                    size="small"
                    inputRef={index === 0 && i === 0 ? ref : null}
                    key={`${i}${index}`}
                    sx={{ margin: "10px", marginLeft: "auto" }}
                    onChange={(e) => handleChange(e, item)}
                    onKeyUp={handleKeyUp}
                    onKeyDown={(e) => handleKeyDown(e, index + i)}
                    value={item.quantity || ""}
                    onBlur={(e) => handleBlur(e, item)}
                  />
                </Box>
              );
            })}
        </Paper>
      ),
    }));

  const options = {
    weekday: "long",
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };

  // console.log("small", matches);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <DialogSave />

      {/* confirm customer and date */}
      <Dialog
        open={open === 1}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            customer name is <b>{order?.customerName?.toLowerCase()}</b>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            order date is -{" "}
            <b>
              {new Date(order?.deliveryDate).toLocaleDateString(
                "en-US",
                options,
              )}
            </b>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            color="error"
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            autoFocus
            onClick={() => {
              fetchGraphql({
                query: `mutation UpdateOrder($orderId: ID!, $order: orderInput) {
                updateOrder(orderId: $orderId, order: $order) {
                  orderStatus
                }
              }`,
                variables: {
                  order: { orderStatus: "Submited" },
                  orderId: id,
                },
              }).then((result) => {
                if (!result.errors) {
                  addAlert({
                    severity: "success",
                    message: "Saved Succesfuly",
                  });
                } else {
                  addAlert({
                    severity: "error",
                    message: "Error updateing order",
                  });
                }

                navigate(`/orders`);
              });
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open === 2}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Preview Order</DialogTitle>
        <Box
          sx={{
            margin: "25px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "7fr 1fr",
              columnGap: "10px",
              overflow: "auto",
            }}
          >
            {orderedProducts.map((item) => (
              <>
                <Box>{item.productName}</Box>
                <Box>{item.quantity}</Box>
              </>
            ))}
          </Box>
        </Box>

        <DialogActions>
          <Button
            color="error"
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            autoFocus
            onClick={() => setOpen(1)}
          >
            next
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open === 3}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please enter a customer name before you submit this order
        </DialogTitle>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            autoFocus
            onClick={() => {
              setOpen(false);
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open === 4}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to DELETE this?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you delete this you will not be able to go back.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            autoFocus
            onClick={() => {
              fetchGraphql({
                query: `mutation deleteOrder ($orderId: ID!) {
                  deleteOrder (orderId: $orderId)
                }`,
                variables: { orderId: id },
              }).then((result) => navigate("/orders"));
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {loading ? (
        <Backdrop
          sx={{
            color: "#ffffff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Box
          sx={{
            display: "flex",
            minWidth: "100%",
            flexDirection: "row",
            [theme.breakpoints.down("sm")]: {
              overflow: "auto",
              scrollSnapType: "x mandatory",
              // scrollSnapPointsY: "391px",
              // height: "100%",
            },
          }}
        >
          {/* <Button
            sx={{ margin: "10px 10px 10px 0px" }}
            variant="contained"
            onClick={() => {
              setPage("order");
            }}
          >
            Back
          </Button> */}

          <FloatingSearchBar
            width={isSmall ? "200px" : ""}
            value={searchField}
            onChange={handleOnChange}
            handleKeyDown={handleSearchKeyDown}
            handleKeyUp={handleKeyUp}
            biRef={biRef}
          />
          <Fab
            sx={{
              position: "fixed",
              bottom: "40px",
              right: "60px",
            }}
            color="primary"
            onClick={() => setSelected(!selected)}
          >
            {selected ? (
              <RadioButtonCheckedIcon />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </Fab>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              [theme.breakpoints.down("sm")]: {
                minWidth: "100%",
                scrollSnapAlign: "start",
              },
              marginTop: "50px",
            }}
          >
            <Feedback />

            <Autocomplete
              disablePortal
              autoSelect={true}
              autoHighlight={true}
              options={customersOptions}
              value={order?.customerName || null}
              onChange={(event, value) => {
                setOrder({
                  ...order,
                  customerId: value.customerId,
                  customerName: value.customerName,
                });

                updateOrder({
                  ...order,
                  customerId: value.customerId,
                });
              }}
              sx={{ minWidth: "250px", marginRight: "10px" }}
              renderInput={(params) => (
                <TextField {...params} label="Customer Name" />
              )}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                margin: "10px 10px 10px 0px",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Delivery Date"
                  openTo="day"
                  views={["year", "month", "day"]}
                  shouldDisableDate={(date) => {
                    const today = new Date();
                    const todayDate = new Date(date);

                    if (
                      canView("admin") &&
                      date < today.setDate(today.getDate() - 1)
                    ) {
                      return true;
                    } else if (date < today.setDate(today.getDate())) {
                      return true;
                    }

                    if (todayDate.getDay() === 6) return true;
                  }}
                  value={order?.deliveryDate || tomorow}
                  onChange={(newValue) => {
                    setOrder({
                      ...order,
                      deliveryDate: newValue,
                    });

                    updateOrder({
                      ...order,
                      deliveryDate: newValue,
                    });
                  }}
                  onBlur={(newValue) => {
                    clearTimeout(stillTypeing);

                    saveOrder({
                      ...order,
                      deliveryDate: newValue,
                    });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>

            <TextField
              sx={{ minWidth: "250px", marginRight: "10px" }}
              multiline
              onChange={(e) => {
                setOrder({
                  ...order,
                  orderNote: e.target.value,
                });

                updateOrder({
                  ...order,
                  orderNote: e.target.value,
                });
              }}
              onBlur={(e) => {
                clearTimeout(stillTypeing);

                saveOrder({
                  ...order,
                  orderNote: e.target.value,
                });
              }}
              label="Order Note"
              value={order?.orderNote || null}
              color="primary"
            />

            <Button
              sx={{ margin: "10px 10px 10px 0px" }}
              variant="contained"
              onClick={() => {
                if (order.customerId) {
                  fetchGraphql({
                    query: `query Products ($orderId: ID!) {
                      orderProducts (orderId: $orderId) {
                        productId
                        productName
                        orderProductId
                        quantity
                      }
                    }`,
                    variables: { orderId: id },
                  }).then((result) => {
                    setOrderedProducts(result.data.orderProducts);
                    setOpen(2);
                  });
                } else {
                  setOpen(3);
                }
              }}
            >
              Submit order
            </Button>

            <Button
              sx={{ margin: "10px 10px 10px 0px" }}
              color="error"
              variant="outlined"
              onClick={() => {
                setOpen(4);
              }}
            >
              Delete order
            </Button>

            {isSmall && <Typography>Swipe left for order sheet</Typography>}
          </Box>
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              [theme.breakpoints.down("sm")]: {
                justifyContent: "center",
                minWidth: "100%",
                height: "100%",
                scrollSnapAlign: "start",
              },
            }}
          >
            <ConfigurableTabs tabs={tabs} />
          </Box>
        </Box>
      )}
    </Box>
  );
}
